export var getPreviousPath = function (path) {
    if (path.endsWith("/")) {
        path = path.slice(0, -1);
    }
    // Remove last path
    var lastSlashIndex = path.lastIndexOf("/");
    if (lastSlashIndex > 0) {
        path = path.substring(0, lastSlashIndex);
    }
    return path;
};
